import IContainerStatusViewModel from "interfaces/IContainerStatusViewModel";

const FillLevelTemplate = (props: IContainerStatusViewModel): any => {
  const container = { props };
  return (
    <>
      <span data-testid={`fill-level-${container.props.id}`} className={`fill-level${container.props.aboveThreshold ? " fill-level-above-threshold" : ""}`}>
        {container.props.fillLevel}
        %
      </span>
    </>
  );
};
export default FillLevelTemplate;
